import React from "react";
import { Switch, SwitchProps, Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import useTheme from "../../../../common/hooks/useTheme";
import { Theme } from "../../../../providers/ThemeProvider";

const StyledSwitch = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 24,
  height: 15,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 1,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(9px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: "#3B3F42",
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color: theme.palette.grey[100],
      ...theme.applyStyles("dark", {
        color: theme.palette.grey[600],
      }),
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: 0.7,
      ...theme.applyStyles("dark", {
        opacity: 0.3,
      }),
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 13,
    height: 13,
  },
  "& .MuiSwitch-track": {
    borderRadius: 13,
    backgroundColor: "#E9E9EA",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: theme.transitions.duration.shortest,
    }),
  },
}));

interface IOSSwitchProps extends SwitchProps {
  leftLabel?: string;
  rightLabel?: string;
  showLabels?: boolean;
}

const IOSSwitch: React.FC<IOSSwitchProps> = ({ 
  leftLabel, 
  rightLabel, 
  showLabels = false, 
  checked, 
  onChange,
  ...props 
}) => {
  const theme: Theme = useTheme();

  if (!showLabels) {
    return <StyledSwitch checked={checked} onChange={onChange} {...props} />;
  }

  return (
    <Box sx={styles.switchContainer}>
      <Typography sx={styles.toggleLabel(theme)}>
        {checked ? rightLabel : leftLabel}
      </Typography>
      <StyledSwitch checked={checked} onChange={onChange} {...props} />
    </Box>
  );
};

const styles = {
  switchContainer: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  toggleLabel: (theme: Theme) => ({
    fontFamily: "var(--font-Medium)",
    fontSize: "12px",
    lineHeight: "17px",
    color: theme.colors_ds.NEUTRAL_TEXT_DEFAULT,
    minWidth: "40px",
  }),
};

export default IOSSwitch;